import { isPhoneApp } from "@/lib/phoneApp";
import { COLORS, Wordmark } from "@/lib/theme";
import { useIsDesktop } from "@/lib/media";

export default function Splash() {
  const isDesktop = useIsDesktop();

  const Core = (
    <div className="anim-pop" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 18 }}>
      <img
        src="/assets/linkshul-logo.png"
        alt="LinkShul"
        data-testid="splash-logo"
        style={{
          width: isDesktop ? 260 : 220,
          height: "auto",
          borderRadius: 24,
          boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
        }}
      />
      <div style={{ marginTop: 4 }}>
        <Wordmark scale={isDesktop ? 1.6 : 1.2} light />
      </div>
      <div style={{ color: "rgba(255,255,255,0.8)", fontWeight: 700, fontSize: isDesktop ? 15 : 13, letterSpacing: 0.4, textAlign: "center", maxWidth: 460 }}>
        {isPhoneApp ? "LinkShul" : "LinkShul"}
      </div>
      <div style={{ direction: "rtl", color: "rgba(255,255,255,0.65)", fontWeight: 700, fontSize: isDesktop ? 16 : 14, marginTop: 6 }}>
        בית כנסת לינקספילד סנדרווד
      </div>
    </div>
  );

  const LoadingLine = (
    <div
      className="anim-bob"
      style={{ position: "absolute", bottom: isDesktop ? 60 : 40, color: "rgba(255,255,255,0.55)", fontWeight: 700, fontSize: 12, letterSpacing: 2 }}
    >
      LOADING · שלום
    </div>
  );

  if (isDesktop) {
    return (
      <div
        data-testid="splash-screen"
        style={{
          position: "relative",
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `linear-gradient(160deg, ${COLORS.purple} 0%, ${COLORS.plum} 100%)`,
          overflow: "hidden",
        }}
      >
        <div style={{ position: "absolute", top: -140, right: -140, width: 460, height: 460, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
        <div style={{ position: "absolute", bottom: -120, left: -120, width: 380, height: 380, borderRadius: "50%", background: "rgba(201,162,75,0.14)" }} />
        {Core}
        {LoadingLine}
      </div>
    );
  }

  return (
    <div
      className="ls-shell"
      data-testid="splash-screen"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(160deg, ${COLORS.purple} 0%, ${COLORS.plum} 100%)`,
      }}
    >
      {Core}
      {LoadingLine}
    </div>
  );
}
